/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListJoinedMoneyPoolsRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {ListJoinedMoneyPoolsResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const listJoinedMoneyPools = (request:ListJoinedMoneyPoolsRequest, options?: CashRequestOptions) => post<ListJoinedMoneyPoolsRequest, ListJoinedMoneyPoolsResponse>("/2.0/cash/list-joined-money-pools", request, {...options, rejectOnError: true })